(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("JSON"));
	else if(typeof define === 'function' && define.amd)
		define(["JSON"], factory);
	else if(typeof exports === 'object')
		exports["io"] = factory(require("JSON"));
	else
		root["io"] = factory(root["JSON"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_5__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition